import { Group, Modal, Stack } from '@mantine/core';
import { useTranslation, Trans } from 'react-i18next';
import { baseWhite, inkLight, redBase, skyDark } from '../../../styles/design-tokens';
import { Button } from '../../../ui-library/button/button';
import { Divider } from '../../../ui-library/divider/divider';
import { Icon } from '../../../ui-library/icon/icon';
import { Text } from '../../../ui-library/typography/typography';

type Props = {
  opened: boolean;
  onClose: () => void;
  onDelete: () => void;
  isDeleting?: boolean;
  initiativeName?: string;
};

export function InitiativeDeleteModal({ opened, onClose, onDelete, isDeleting = false, initiativeName }: Props) {
  const i18n = useTranslation();
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      size={580}
      padding={24}
      withCloseButton={false}
      styles={{
        content: {
          borderRadius: 8,
          boxShadow: 'var(--box-shadow-big-soft)',
        },
      }}
    >
      <Stack gap={24}>
        <Group justify="space-between" align="center">
          <Text size="large" weight="bold">
            {i18n.t('strategy.initiatives.delete.title')}
          </Text>
          <Icon name="close" size={24} color={skyDark} onClick={onClose} pointer />
        </Group>
        <Divider />
        <Stack gap={16}>
          <Text size="medium">
            <Trans
              i18nKey="strategy.initiatives.delete.description_first"
              values={{ name: initiativeName || 'initiative' }}
              components={{ strong: <strong /> }}
            />
          </Text>
          <Text size="medium">{i18n.t('strategy.initiatives.delete.description_second')}</Text>
        </Stack>
        <Divider />
        <Group justify="flex-end" gap={16}>
          <Button
            radius="xl"
            variant="outline"
            onClick={onClose}
            disabled={isDeleting}
            style={{ borderColor: inkLight }}
          >
            <Text weight="medium" style={{ color: inkLight }}>
              {i18n.t('strategy.initiatives.form.cancel')}
            </Text>
          </Button>
          <Button
            radius="xl"
            onClick={onDelete}
            loading={isDeleting}
            disabled={isDeleting}
            style={{ backgroundColor: redBase }}
            rightSection={<Icon variant="filled" name="delete" color={baseWhite} size={16} pointer />}
          >
            <Text weight="medium" style={{ color: baseWhite }}>
              {i18n.t('strategy.initiatives.delete.confirm')}
            </Text>
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
